const subElementMixin = {
    data() {
        return {
            componentId: +new Date(),
            dialogVisible: false,
            instance: {
                elements: [],
            },
            element: { data: {} },
        }
    },
    methods: {
        initSelf() {
            this.initInstance();
        },
        // 每个复合组件必须要实现的方法
        initInstance() {},
        newSub(type, alias = null) {
            let types = this.types;
            var object = null;
            for (var i in types) {
                if (types[i].type == type) {
                    object = types[i];
                    break;
                }
            }
            object.id = null;
            object.sign = this.createSign(13); //唯一标识
            object.data = null;
            object.alias = alias;
            return object;
        },
        addSub(type, alias = null) {
            var element = this.newSub(type, alias);
            this.instance.elements.push(this.clone(element));
        },
        moveUpSub(index) {
            if (index == 0) {
                return;
            }
            var prev = this.instance.elements[index - 1];
            var current = this.instance.elements[index];
            this.instance.elements.splice(index - 1, 1, current);
            this.instance.elements.splice(index, 1, prev);
        },
        moveDownSub(index) {
            if (index == this.instance.elements.length - 1) {
                return;
            }
            var next = this.instance.elements[index + 1];
            var current = this.instance.elements[index];
            this.instance.elements.splice(index + 1, 1, current);
            this.instance.elements.splice(index, 1, next);
        },
        delSub(index) {
            this.instance.elements.splice(index, 1);
        },
        editSub(index) {
            this.componentId = +new Date();
            this.dialogVisible = true;
            this.element = this.instance.elements[index];
        },
        emptyData() {
            return this.instance.elements.length == 0;
        },
        closeComponent() {
            this.dialogVisible = false;
        },
    }
};
export default subElementMixin;